<div class="errwrap">
  <div class="errdiv1" id="errs"></div>
</div>

<div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title">{{ screentitle }}</h1>

      <div class="button-wrapper bothbuttdiv2">
        <div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="btn back-button button-margin ">
          <!-- //****************** -->

          <button class="approved" [disabled]="RAC_APROVE != 1" *ngIf="isApproved && actionmode == 'Edit'">

            <span class="bold">Approved</span>
          </button>
          <input type="button" [disabled]="RAC_APROVE != 1" class="btn btn-success commonbutt"
            style="width: 80px;font-weight: 700" value="Active" id="btnname" (click)="changeName()"
            *ngIf="isApproved && actionmode == 'Edit'" />
          <!-- //****************** -->

          <button [disabled]="
              nameExist ||
              showList == true ||
              viewpage == true ||
              invalidCityName ||
              onlyspclchar ||
              onlynum ||
              exceedLength ||
              notAlphabet ||
              minlength ||
              cnameExceed ||
              mincityname ||
              onlynumc ||
              refundableMinLength ||
              nonRefundableMinLength
            " class="btn btn-success commonbutt" type="button" (click)="submitdata()">
            <em class="fa fa-check"></em>&nbsp;Submit
          </button>

          <button class="btn btn-success commonbutt" type="button"
            *ngIf="!isApproved && updateApprove && RAC_APROVE == '1'" data-toggle="modal" data-target="#myModal">
            <em class="fa fa-thumbs-up "></em>&nbsp;&nbsp;
            <span class="bold">Approve</span>
          </button>
          <button class="btn btn-warning commonbutt" type="button"
            *ngIf="!isApproved && updateApprove && RAC_APROVE == '1'" data-toggle="modal" data-target="#myModal2">
            <em class="fa fa-thumbs-down"></em> <span class="bold">Reject</span>
          </button>

          <button class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close
          </button>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div>
                  <div>
                    <div>
                      <div class="errwrap">
                        <div class="errdiv1" id="err"></div>
                      </div>
                      <div class="col-lg-3">
                        <label>Select Fare Products</label>
                        <select class="form-control" [disabled]="actionmode == 'Edit'"
                          [(ngModel)]="screen_details.FARE_PRODUCT_LABEL" [disabled]="showList == true"
                          (blur)="checkNames()" (input)="checkEdit()">
                          <option disabled value="">--Select--</option>

                          <option *ngFor="let fareProductLabel of fareProductLabels" value={{fareProductLabel.key}}>
                            {{fareProductLabel.value}}</option>
                        </select>
                        <span *ngIf="nameExist" style="color: red">Fare product already exist</span>
                      </div>
                      <div class="col-lg-3">
                        <label>Fare Rule for Refundable Flight</label>
                        <input [(ngModel)]="screen_details.REFUNDABLE_FARE_RULE" maxlength="500"
                          [disabled]="showList == true" type="text" class="form-control"
                          placeholder="Enter Refundable Rule" (change)="gotochangestatus()"
                          (blur)="checkRefundable($event.target.value)"
                          (input)="checkRefundableLength($event.target.value)" />
                        <span *ngIf="refundableMinLength" style="color: red">Min limit is 10 char.</span>
                        <span *ngIf="refundableExceedLength" style="color: red">Max limit is 500 char.</span>
                      </div>
                      <div class="col-lg-3">
                        <label>Fare Rule for Non Refundable Flight</label>
                        <input [(ngModel)]="screen_details.NONREFUNDABLE_FARE_RULE" type="text" maxlength="500"
                          [disabled]="showList == true" class="form-control" placeholder="Enter Non-Refundable Rule"
                          (change)="gotochangestatus()" (blur)="checkNonRefundable($event.target.value)" (input)="
                            checkNonRefundableLength($event.target.value)
                          " />
                        <span *ngIf="nonRefundableMinLength" style="color: red">Min limit is 10 char.</span>
                        <span *ngIf="nonRefundableExceedLength" style="color: red">Max limit is 500 char.</span>
                      </div>
                      <div class="clr"></div>
                      <div class="divider"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ########## -->
<div class="modal fade" id="myModal" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="padding:20px 31px;">
        <button type="button" (click)="clearRemark()" class="close" data-dismiss="modal">
          &times;
        </button>
        <h4 class="modal-title">
          <span class="glyphicon glyphicon-thumbs-up" style="margin-right: 10px"></span>Do you want to approve ?
        </h4>
      </div>

      <div class="modal-body">
        <div class="col-lg-13">
          <label> Remarks</label>
          <textarea 
          [(ngModel)]="aprove_details.APPROVAL_REMARKS" 
          (input)="getremark($event.target.value)" (blur)="checkRemarkLength($event.target.value)" rows="8" cols="20" type="text" class="form-control m-input"
            placeholder="Enter  Remarks">
          </textarea>
          <span *ngIf="minRemark" 
          class="m-form__help" style="color: red">Please enter Remarks with minimum length
            3</span>
        </div>
      </div>
      <div class="modal-footer">
        <button 
        [disabled]="!aprvbtn" class="btn btn-success" type="button" 
        (click)="aproveReject(1)"
          data-dismiss="modal">
          <span class="bold">Yes</span>
        </button>

        <button 
        class="btn btn-warning " 
        (click)="clearRemark()" type="button" data-dismiss="modal">
          <span class="bold">No</span>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- ########## -->

<!-- ########## -->
<div class="modal fade" id="myModal2" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="padding:20px 31px;">
        <button type="button" 
        class="close" 
        (click)="clearRemark()" data-dismiss="modal">
          &times;
        </button>
        <h4 class="modal-title">
          <span 
          class="glyphicon glyphicon-thumbs-down" 
          style="margin-right: 10px"></span>Do you want to reject ?
        </h4>
      </div>
      <div class="modal-body">
        <div class="col-lg-13">
          <label>Remarks</label>
          <textarea rows="8" 
          (input)="getremark($event.target.value)"
          [(ngModel)]="aprove_details.APPROVAL_REMARKS"
            (blur)="checkRemarkLength($event.target.value)" 
            cols="20" type="text" class="form-control m-input"
            placeholder="Enter  Remarks">
          </textarea>
          <span class="m-form__help"
          *ngIf="minRemark"  style="color: red">Please enter Remarks with minimum length
            3</span>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-success" 
        [disabled]="!aprvbtn"  type="button" 
        (click)="aproveReject(2)"
          data-dismiss="modal">
          <span class="bold">Yes</span>
        </button>
        <button 
        class="btn btn-warning " type="button" 
        (click)="clearRemark()" data-dismiss="modal">
          <span class="bold">No</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ########## -->

<div *ngIf="actionmode != 'Add' && actionmode != 'Edit' && actionmode != 'View'" class="searchdiv">
  <div class="headerdiv">
    <h1>{{ screentitle }}</h1>
    <div class="bothbuttdiv">
      <button class="btn btn-primary commonbutt" type="button" *ngIf="RAC_ADD == '1'" (click)="addForm()">
        <em class="fa fa-plus-circle"></em>&nbsp;Add New
      </button>

    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-div">
          <div class="row">
            <div class="m-portlet">
              <div style="padding: 2% 2% 2% 2%">
                <div>
                  <div>
                    <div class="col-lg-3">
                      <label>Fare Products</label>
                      <select class="form-control" [(ngModel)]="search_details.FARE_PRODUCT_LABEL">
                        <option value="">--Select Fare Products--</option>
                        <option *ngFor="let fareProductLabel of searchFareProductLabels" value={{fareProductLabel.key}}>
                          {{fareProductLabel.value}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="btn clear-button button-margin">
                  <button class="btn btn-primary commonbutt" style="margin-top:21px" (click)="searchData()"
                    type="button">
                    <em class="fa fa-search "></em>&nbsp;Search
                  </button>
                </div>
              </div>
              <div class="errwrap">
                <div class="errdiv1" id="err"></div>
              </div>
              <div *ngIf="searchresult" class="reportstatus" [hidden]="searchlist">

                <table aria-describedby="fareRulesMasterData" class="table table-striped" [mfData]="serachtabledata"
                  [mfRowsOnPage]="5">
                  <thead>
                    <tr>
                      <th scope="col" style="width: 20%" *ngIf="RAC_VIEW == '1' || RAC_EDIT == '1'">
                        Actions
                      </th>

                      <th scope="col" style="width: 20%">
                        <mfDefaultSorter by="JOURNEY_NAME">Fare Product Label
                        </mfDefaultSorter>
                      </th>
                      <th scope="col" style="width: 20%">
                        <mfDefaultSorter by="JOURNEY_NAME">Status</mfDefaultSorter>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="
                        let item of (serachtabledata
                          | paginate: { itemsPerPage: 3, currentPage: p })
                      ">
                      <td *ngIf="RAC_VIEW == '1' || RAC_EDIT == '1'">
                        <button class="btn btn-default btn-circle" *ngIf="RAC_VIEW == '1'" type="button"
                          (click)="showFormData(item.FARE_RULES_ID, 1, 1, 1)">
                          <em class="fa fa-eye"></em>
                        </button>
                        <span *ngIf="item.STATUS != '2' && item.PRE_APPROVE != '1'">
                          <button class="btn btn-default btn-circle" *ngIf="RAC_EDIT == '1'" type="button" (click)="
                              showFormData(
                                item.FARE_RULES_ID,
                                2,
                                item.STATUS,
                                item.APPROVAL_STATUS
                              )
                            ">
                            <em class="fa fa-pencil"></em>
                          </button>
                        </span>
                      </td>
                      <td *ngIf="item.FARE_PRODUCT_LABEL=='ECOFP1'">Economy</td>
                      <td *ngIf="item.FARE_PRODUCT_LABEL=='ECOFP2'">Economy Plus</td>
                      <td *ngIf="item.FARE_PRODUCT_LABEL=='ECOFP3'">Economy pro</td>
                      <td *ngIf="item.FARE_PRODUCT_LABEL=='BUSFP1'">Premium</td>
                      <td>



                        <div *ngIf="
                            item.APPROVAL_STATUS == 0 &&
                            item.STATUS == 0 &&
                            item.PRE_APPROVE != 1
                          ">
                          <span class="icls1">
                            <button class="btn commonbutt zol1">
                              Inactive
                            </button>

                            <span class="tooltiptext">Not Approved</span>
                          </span>
                        </div>

                        <div *ngIf="
                            item.APPROVAL_STATUS == 1 && item.PRE_APPROVE != 1
                          ">
                          <span class="icls1">
                            <button class="btn  commonbutt zol" *ngIf="item.STATUS == 1">
                              Active
                            </button>

                            <button class="btn  commonbutt zol1" *ngIf="item.STATUS == 0">
                              Inactive
                            </button>

                            <span class="tooltiptext"> Approved </span>

                          </span>
                        </div>
                        <div *ngIf="
                          item.APPROVAL_STATUS == 0 && item.PRE_APPROVE == 1
                        ">
                          <span class="icls1">
                            <button class="btn  commonbutt zol">
                              Active
                            </button>

                            <span class="tooltiptext"> Approved </span>

                          </span>
                        </div>


                        <div *ngIf="item.APPROVAL_STATUS == 2 && item.STATUS == 2">
                          <span class="icls5">
                            <button class="btn  commonbutt zol1">
                              Inactive
                            </button>

                            <span class="tooltiptext">Rejected</span>
                          </span>
                        </div>


                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="4">

                        <pagination-controls (pageChange)="p = $event"></pagination-controls>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div *ngIf="loader">
                <div style="margin: 0 auto; text-align: center;">
                  <img src="../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader">

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="actionmode == 'View'" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title" *ngIf="showList == !false">{{ viewTitle }}</h1>
      <h1 class="screen-title" *ngIf="showList == false">
        {{ insertDataTitle }}
      </h1>
      <div class="button-wrapper bothbuttdiv2">
        <div *ngIf="actionmode == 'View'" class="btn back-button button-margin ">
          <button class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close
          </button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div>
                  <div>
                    <div>
                      <div class="tdive">
                        <table aria-describedby="fareProductData" class="viewtable">
                          <div *ngFor="let q of serachTableInfo">
                            <tr>
                              <th scope="col">
                                <span class="vlbl">Fare Product Lable </span>
                              </th>
                              <td>
                                <span class="vVal">{{
                                  q.FARE_PRODUCT_LABEL
                                  }}</span>
                              </td>
                            </tr>

                            <tr>
                              <th scope="col">
                                <span class="vlbl">Refundable Fare Rule</span>
                              </th>
                              <td>
                                <span class="vVal">{{
                                  q.REFUNDABLE_FARE_RULE
                                  }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="col">
                                <span class="vlbl">Non Refundable Fare Rule</span>
                              </th>
                              <td>
                                <span class="vVal">
                                  {{ q.NONREFUNDABLE_FARE_RULE }}
                                </span>
                              </td>
                            </tr>
                          </div>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>